import React from "react";

interface GridDetailItemProps {
  label: string;
  data: React.ReactNode;
  withButton?: React.ReactNode;
}

export default function GridDetailItem({
  label,
  data = "-",
  withButton,
}: GridDetailItemProps) {
  if (withButton) {
    return (
      <div className="d-flex p-3 justify-content-around align-items-center bg-secondary-subtle rounded-1">
        <div className="me-2">
          <h3 className="font-14 mb-1">{label}</h3>
          {typeof data === "string" ? <p className="">{data}</p> : <>{data}</>}
        </div>
        <>{withButton}</>
      </div>
    );
  }
  return (
    <div className="mb-3">
      <h3 className="font-14 mb-1">{label}</h3>
      {typeof data === "string" ? <p className="">{data}</p> : <>{data}</>}
    </div>
  );
}
